<script>
export default {
    food_drinks: "Essen & Getränke",
    shopping: "Einkaufen",
    home: "Zuhause",
    transport: "Transport",
    vehicles: "Fahrzeuge",
    entertainment: "Unterhaltung",
    communication_pc: "Kommunikation PC",
    financial_expenses: "Finanzausgaben",
    income: "Einnahmen",
    other: "Sonstiges",
    bars_venues: "Bars & Lokale",
    restaurants_fast_food: "Restaurants & Fast-Food",
    groceries: "Lebensmittel",
    clothing_shoes: "Kleidung & Schuhe",
    pets: "Haustiere",
    beauty_wellness: "Schönheit & Wellness",
    stationery_tools: "Schreibwaren & Werkzeuge",
    home_garden: "Haus & Garten",
    electronics_accessories: "Elektronik, Zubehör",
    pharmacy: "Apotheke",
    kids: "Kinder",
    jewelry_accessories: "Schmuck & Accessoires",
    gift_expenses: "Geschenkausgaben",
    family_help: "Familienhilfe",
    leisure: "Freizeit",
    rent: "Miete",
    property_insurance: "Immobilienversicherung",
    condominium: "Wohnungseigentum",
    energy_utilities: "Energie & Nebenkosten",
    maintenance: "Wartung",
    mortgage: "Hypothek",
    taxi: "Taxi",
    public_transport: "Öffentlicher Verkehr",
    travel: "Reisen",
    business_trips: "Geschäftsreisen",
    vehicle_insurance: "Fahrzeugversicherung",
    fuel: "Kraftstoff",
    vehicle_maintenance: "Fahrzeugwartung",
    rentals: "Mieten",
    parking: "Parken",
    tolls: "Maut",
    alcohol: "Alkohol",
    tobacco: "Tabak",
    culture_sports_events: "Kultur, Sportveranstaltungen",
    donations_charity: "Spenden, Wohltätigkeit",
    events: "Veranstaltungen",
    wedding: "Hochzeit",
    education_development: "Bildung, Entwicklung",
    hobbies: "Hobbys",
    books_audio_subscriptions: "Bücher, Audio, Abonnements",
    lotteries_gambling: "Lotterien & Glücksspiel",
    health: "Gesundheit",
    sports_fitness: "Sport, Fitness",
    tv_streaming: "TV & Streaming",
    holidays: "Urlaub",
    hotels: "Hotels",
    internet: "Internet",
    postal_services: "Postdienste",
    software_apps_games: "Software, Apps & Spiele",
    phone: "Telefon",
    insurance: "Versicherungen",
    consulting: "Beratung",
    fines: "Bußgelder",
    loans_interest: "Kredite & Zinsen",
    taxes: "Steuern",
    taxes_fees: "Steuern, Gebühren",
    real_estate: "Immobilien",
    movable_goods: "Bewegliche Güter",
    financial_investments: "Finanzinvestitionen",
    collections: "Einzüge",
    savings: "Ersparnisse",
    checks: "Schecks",
    coupons: "Gutscheine",
    family_allowance: "Familienzulage",
    rental_income: "Mieteinnahmen",
    interest_dividends: "Zinsen, Dividenden",
    loans_rentals: "Kredite, Vermietungen",
    gifts: "Geschenke",
    refunds: "Rückerstattungen (Steuern, Einkäufe)",
    salary: "Gehalt",
    sales: "Verkäufe",
    transfer: "Überweisung",
    //payment methods
    cash: "Bargeld",
    credit_card: "Kreditkarte",
    debit_card: "Debitkarte",
    transfer_back: "Überweisung",
    check: "Scheck",
    // currencies
    us_dollar: "US-Dollar",
    euro: "Euro",
    british_pound: "Britisches Pfund",
    japanese_yen: "Japanischer Yen",
    swiss_franc: "Schweizer Franken",
    canadian_dollar: "Kanadischer Dollar",
    australian_dollar: "Australischer Dollar",
    new_zealand_dollar: "Neuseeland-Dollar",
    swedish_krona: "Schwedische Krone",
    norwegian_krone: "Norwegische Krone",
    danish_krone: "Dänische Krone",
    singapore_dollar: "Singapur-Dollar",
    hong_kong_dollar: "Hongkong-Dollar",
    chinese_yuan: "Chinesischer Yuan",
    russian_ruble: "Russischer Rubel",
    indian_rupee: "Indische Rupie",
    indonesian_rupiah: "Indonesische Rupiah",
    brazilian_real: "Brasilianischer Real",
    mexican_peso: "Mexikanischer Peso",
    argentine_peso: "Argentinischer Peso",
    dues_grants: "Beiträge, Zuschüsse",
    pastry_shop: "Bar, Konditorei",
    pub: "Pub",
    transportation: "Transport",
    investments: "Investitionen",
    food_beverages: "Essen & Getränke",
    computer_communication: "Kommunikation PC",
    wallet_name: "Portemonnaie Name",
    months: {
        jan: 'Jan',
        january: 'Januar',
        feb: 'Feb',
        february: 'Februar',
        mar: 'Mär',
        march: 'März',
        apr: 'Apr',
        april: 'April',
        may: 'Mai',
        jun: 'Jun',
        june: 'Juni',
        jul: 'Jul',
        july: 'Juli',
        aug: 'Aug',
        august: 'August',
        sep: 'Sep',
        september: 'September',
        oct: 'Okt',
        october: 'Oktober',
        nov: 'Nov',
        november: 'November',
        dec: 'Dez',
        december: 'Dezember',
    },
    bank_accounts: {
        bank: 'Bank',
        cache: 'Bargeld',
        "credit-card": 'Kreditkarte',
        "credit-card-revolving": 'Revolving-Kreditkarte',
        investment: 'Investition',
        loan: 'Kredit',
        other: 'Sonstiges',
        "prepaid-card": 'Prepaid-Karte',
        voucher: 'Gutschein'
    },
    stats_by_category: 'Statistiken nach Kategorie',
    stats_by_tags: 'Statistiken nach Tags',
}
</script>
